/** Base URL for Stripe checkout API (e.g. https://checkout-api.example.com). Empty = CRA dev proxy `/api`. */
export function getCheckoutApiBase(): string {
  const base = process.env.REACT_APP_CHECKOUT_API_URL?.replace(/\/$/, '') ?? '';
  return base;
}

export async function createCheckoutSession(bookingId: string): Promise<{ url?: string; error?: string }> {
  const base = getCheckoutApiBase();
  const endpoint = base ? `${base}/api/create-checkout-session` : '/api/create-checkout-session';

  const res = await fetch(endpoint, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ bookingId }),
  });

  let body: unknown;
  try {
    body = await res.json();
  } catch {
    return { error: `Could not parse response (${res.status})` };
  }

  const o = body as { url?: string; error?: string };
  if (!res.ok) {
    return { error: o?.error || `Request failed (${res.status})` };
  }

  return { url: o.url };
}
